<template>
  <div class="pa-0 ma-0">
    <TextField
      v-if="componentType == 'TextField'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />
    <NumberField
      v-if="componentType == 'NumberField'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />
    <Textarea
      v-if="componentType == 'Textarea'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />
    <SelectTextOption
      v-if="componentType == 'SelectTextOption'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />
    <SelectMultipleTextOptions
      v-if="componentType == 'SelectMultipleTextOptions'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />
    <ProductsCards
      v-if="componentType == 'ProductsCards'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />
    <ProductsCardsRadio
      v-if="componentType == 'ProductsCardsRadio'"
      :field="field"
      :onChange="onComponentChange"
      :defaultValue="getDefaultValue(field._id)"
    />

    <v-btn rounded class="mb-2" v-if="!field.hasComment" @click="addComment(field)">
      <v-icon>mdi-plus</v-icon>
      Add comment</v-btn
    >
    <v-textarea
      v-model.trim="field.data.comment"
      clearable
      no-resize
      auto-grow
      :counter="counter"
      outlined
      placeholder="Type comment"
      rounded
      :rows="3"
      solo
      validate-on-blur
      :maxlength="counter"
      :maxHeight="'200px'"
      v-if="field.hasComment"
      ref="comment"
    ></v-textarea>
  </div>
</template>

<script>
import TextField from './c/TextField'
import NumberField from './c/NumberField'
import Textarea from './c/TextArea'
import SelectTextOption from './c/SelectTextOption'
import ProductsCards from './c/ProductsCards'
import ProductsCardsRadio from './c/ProductsCardsRadio'
import SelectMultipleTextOptions from './c/SelectMultipleTextOptions'
import FIELD_TYPES from '@/constants/fieldTypes'
import TEXT_TYPES from '@/constants/textTypes'
import IMAGE_MODES from '@/constants/imageModes'
import { mapGetters } from 'vuex'

export default {
  name: 'FormField',
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: String,
      default: ''
    },
    counter: {
      type: Number,
      default: 1000
    },
    isCommentVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      FIELD_TYPES,
      TEXT_TYPES,
      IMAGE_MODES
    }
  },
  components: {
    TextField,
    NumberField,
    Textarea,
    SelectTextOption,
    SelectMultipleTextOptions,
    ProductsCards,
    ProductsCardsRadio
  },
  watch: {
    isCommentVisible(value) {
      return this.field.data.hasComment
    }
  },
  updated() {
    if (this.field.hasComment && !this.field.data.comment) {
      this.$refs.comment.focus()
    }
  },
  computed: {
    componentType() {
      switch (this.field.data.type) {
        case FIELD_TYPES.TEXT:
          {
            switch (this.field.data.attrs.textType) {
              case TEXT_TYPES.TEXTAREA:
                return 'Textarea'
                break
              default:
                return 'TextField'
                break
            }
          }
          break
        case FIELD_TYPES.NUMBER:
          return 'NumberField'
          break
        case FIELD_TYPES.SELECT_OPTIONS:
          {
            if (this.field.data.imageMode == IMAGE_MODES.CARDS) {
              if (this.field.data.multiple) {
                return 'ProductsCards'
              } else {
                return 'ProductsCardsRadio'
              }
            }
            if (this.field.data.multiple) {
              return 'SelectMultipleTextOptions'
            }
            return 'SelectTextOption'
          }
          break

        default:
          throw new Error('Wrong field type')
          break
      }
    }
  },
  methods: {
    ...mapGetters('order', ['getEditedOrder']),
    addComment(field) {
      this.$set(field, 'hasComment', true)
    },
    onComponentChange(obj) {
      obj.valid =
        obj.valid && (!this.field.data.comment || this.field.data.comment.length < this.counter)

      this.onChange(obj)
    },
    // getCommentRules(){
    //   return [v => v && v.length <= this.counter || `Max ${this.counter} characters`]
    // },
    checkCommentLength(e) {
      if (this.field.data.comment.length > this.counter) {
        alert(`Max comment length is ${this.counter} characters`)
        this.field.data.comment = this.field.data.comment.slice(0, this.counter)
        e.stopPropagation()
        return false
      }
    },
    getDefaultValue(fieldId) {
      const editedOrder = this.getEditedOrder()
      if (editedOrder) {
        if (editedOrder.fieldsValues[fieldId]) {
          return editedOrder.fieldsValues[fieldId].rawValues
        }
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped></style>
